import React, {useCallback, useEffect, useState} from "react";
import {PaginationModel} from "../../models/pagination.model";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import {toggleLoader} from "../../store/global/global-slice";
import {PublisherService} from "../../services/publisher.service";
import {Grid} from "@mui/material";
import {StyledButton} from "../../components/ui-base/button";
import {EmptyBookShort} from "../../components/author/books/empty-book-short";
import {ForeignBookModel} from "../../models/foreign-book.model";
import {ForeignBookList} from "../../components/publisher/foreign-books/foreign-book-list";
import {SearchBooks} from "../../components/publisher/books/search-books";
import {LastSearchData} from "../../models/view/last-search-data.model";
import {useTranslation} from "react-i18next";

const PublisherForeignBooks = () => {
    const [books, setBooks] = React.useState<PaginationModel<ForeignBookModel[]>>(null);
    const [lastSearchData, setLastSearchData] = useState<LastSearchData>({searchValue: '', sortFieldValue: 'submitted_date', sortValue: 'desc'});
    const [loaded, setLoaded] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation(['publisher', 'common']);

    const loadBooks = useCallback(async (
        sortFieldTmp,
        sortValueTmp,
        searchValueTmp,
        page = 0,
        perPage = 8
    ) => {
        dispatch(toggleLoader(true));

        const booksRes = await PublisherService.getForeignBooks(searchValueTmp, sortFieldTmp, sortValueTmp, page, perPage);

        setBooks(oldBooks => {
            if (page === 0) {
                return booksRes;
            } else {
                return {
                    ...booksRes,
                    results: [...oldBooks.results, ...booksRes.results]
                };
            }
        })
        setLoaded(true);
        dispatch(toggleLoader(false));

    }, [dispatch]);

    useEffect(() => {
        loadBooks(lastSearchData.sortFieldValue, lastSearchData.sortValue, lastSearchData.searchValue);
    }, [loadBooks, lastSearchData]);

    const loadNextBooks = () => {
        if (books.next) {
            loadBooks(lastSearchData.sortFieldValue, lastSearchData.sortValue, lastSearchData.searchValue,books.results.length / 8, 8);
        }
    }

    const loadManuscripts = async (sortFieldTmp, sortValueTmp, searchValueTmp) => {
        setLastSearchData({
            sortValue: sortValueTmp,
            sortFieldValue: sortFieldTmp,
            searchValue: searchValueTmp
        });
    }

    return (
        <Grid container direction={"column"}>
            <SearchBooks loadManuscripts={loadManuscripts}/>

            {books &&
            <Grid container direction={"column"} spacing={1}>
                {books.results.map((book, index) => (
                    <Grid item key={index}>
                        <ForeignBookList book={book}/>
                    </Grid>
                ))}
            </Grid>
            }

            {books && books.next &&
            <Grid container direction={"row"} justifyContent={"center"} style={{marginTop: '30px'}}>
                <StyledButton type={"button"} color={"transparent"} onClick={() => {loadNextBooks()}}>
                    {t('foreignBooks.showNext')}
                </StyledButton>
            </Grid>
            }

            {books && books.results.length === 0 && loaded &&
            <EmptyBookShort
                title={t('foreignBooks.notFound')}
                description={''}
                showButton={false}
            />
            }
        </Grid>
    );
}

export default PublisherForeignBooks;
